import script from "./AddMenuBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddMenuBtn.vue?vue&type=script&setup=true&lang=ts"

import "./AddMenuBtn.vue?vue&type=style&index=0&id=3a17524c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a17524c"]])

export default __exports__